//-- Copyright (c) 2021 TMT Insights Group, LLC
import { DataTableConfig } from '@/__configs/config_types';
import { DeepPartial, OrderJob } from '@/redux/slices/slice_types';
import { defaultFilters, FilterIDType, NewFilterTypesMap } from '@tmt-insights/oms_fe_core/columns';

const dataConfig: DeepPartial<DataTableConfig> = {
  orders: {
    filters: [
      defaultFilters.status,
      defaultFilters.customer,
      defaultFilters.profile,
      defaultFilters.billableClient,
      defaultFilters.managedBy,
      defaultFilters.createdAt,
      // defaultFilters.dueDate,
      defaultFilters.filterId,
      defaultFilters.search
    ],
    quickFilters: [
      defaultFilters.status,
      defaultFilters.customer,
      defaultFilters.profile,
      defaultFilters.billableClient,
      defaultFilters.managedBy,
      defaultFilters.createdAt,
      // defaultFilters.dueDate,
      defaultFilters.filterId,
      defaultFilters.search
    ],
    parseDataFn: ({ data }) =>
      data?.map((order) => {
        const jobsCopy = JSON.parse(JSON.stringify(order.jobs));
        jobsCopy.sort((a: OrderJob, b: OrderJob) => a.id - b.id);
        return { ...order, jobs: jobsCopy };
      })
  },
  jobs: {
    filters: [
      defaultFilters.jobType,
      defaultFilters.stage,
      defaultFilters.status,
      defaultFilters.dueDate,
      defaultFilters.createdAt,
      defaultFilters.completedAt,
      defaultFilters.managedBy,
      defaultFilters.customer,
      defaultFilters.profile,
      defaultFilters.outputNetwork,
      defaultFilters.filterId,
      defaultFilters.search
    ],
    quickFilters: [
      defaultFilters.jobType,
      defaultFilters.stage,
      defaultFilters.status,
      defaultFilters.dueDate,
      defaultFilters.createdAt,
      defaultFilters.completedAt,
      defaultFilters.managedBy,
      defaultFilters.customer,
      defaultFilters.profile,
      defaultFilters.outputNetwork,
      defaultFilters.filterId,
      defaultFilters.search
    ],
    filterOptions: {
      profile: ['showDeleted']
    }
  },
  tasks: {
    filters: [
      defaultFilters.taskType,
      defaultFilters.status,
      defaultFilters.assignedUsers,
      defaultFilters.dueDate,
      defaultFilters.createdAt,
      defaultFilters.showNotReady,
      defaultFilters.outputNetwork,
      defaultFilters.broadcastLength,
      defaultFilters.filterIdNoJobAsset,
      defaultFilters.search
    ],
    quickFilters: [
      defaultFilters.taskType,
      defaultFilters.status,
      defaultFilters.assignedUsers,
      defaultFilters.dueDate,
      defaultFilters.createdAt,
      defaultFilters.showNotReady,
      defaultFilters.outputNetwork,
      defaultFilters.broadcastLength,
      defaultFilters.filterIdNoJobAsset,
      defaultFilters.search
    ],

    // orderOnPriorityAsArray: true,
    multiSort: true,
    preset: {
      sorting: ['priority', '-created_at']
    }
  },
  pendingAssets: {
    filters: [
      defaultFilters.status,
      defaultFilters.assignedGroups,
      defaultFilters.assignedUsers,
      defaultFilters.dueDate,
      {
        id: 'filter_id',
        label: 'Search by ID',
        options: () => [FilterIDType.ASSET_ID],
        type: NewFilterTypesMap.ID
      },
      defaultFilters.search
    ],
    quickFilters: [
      defaultFilters.status,
      defaultFilters.assignedGroups,
      defaultFilters.assignedUsers,
      defaultFilters.dueDate,
      {
        id: 'filter_id',
        label: 'Search by ID',
        options: () => [FilterIDType.ASSET_ID],
        type: NewFilterTypesMap.ID
      },
      defaultFilters.search
    ]
  },
  titles: {
    baseUrl: '/inventory/titles/',
    label: 'titles',
    title: 'Titles',
    filters: [defaultFilters.search],
    quickFilters: [defaultFilters.search],
    preset: {
      sorting: {
        id: 'created_at',
        order: 'desc'
      },
      filters: { type: null }
    },
    params: {
      entity_types_filter: ['feature', 'series', 'episode'],
      thumbnails: true
    }
  },
  profiles: {
    disableExport: true
  },
  jobDetailTasks: {
    params: {
      name_filter: [
        'no_te_edit_task',
        'edit_task',
        'core_fix_edit_task',
        'tech_review_task',
        'tech_review_job_task',
        'internal_bcm_qc_task',
        'edm_internal_bcm_qc_task'
      ]
    }
  },
  titleDetailJobs: {
    preset: {
      sorting: {
        id: 'id',
        order: 'desc'
      }
    }
  },
  fileIngest: {
    title: 'Ingest Manager',
    baseUrl: '/inventory/file_ingests/',
    label: 'files',
    filters: [defaultFilters.fileType, defaultFilters.status, defaultFilters.createdAt, defaultFilters.search],
    quickFilters: [defaultFilters.fileType, defaultFilters.status, defaultFilters.createdAt, defaultFilters.search],
    preset: {
      sorting: {
        id: 'created_at',
        order: 'desc'
      }
    }
  }
};

export default dataConfig;
